export const RacemapColors = {
  CloudBlue: '#ced9e3',
  PaleBlue: '#36739a',
  LightBlue: '#f0f5fa',
  DarkRed: '#721c25',
  DangerRed: '#FF4D4F',
  DustRed1: '#fff1f0',
  DustRed2: '#ffccc7',
  BaseRed: '#ff4646',
  AltRed: '#f53838',
  LightRed: '#f8d7da',
  LightLightRed: '#fef2f2',
  LightYellow: '#fcda9f',
  LightLightYellow: '#fefbea',
  BaseYellow: '#ffff00',
  LightLightGreen: '#f6ffed',
  LightGreen: '#b7eb8f',
  BaseGreen: '#52c41a',
  DarkGreen: '#008000',
  PolarGreen1: '#f6ffed',
  PolarGreen2: '#d9f7be',
  LightGray: '#dee2e6',
  LightLightGray: '#f2f2f2',
  LightLightLightGray: '#fafafa',
  Gray: '#ced4da',
  DarkGray: '#646464',
  DarkYellow: '#d4b106',
  SunriseYellow1: '#feffe6',
  SunriseYellow2: '#ffffb8',
  DarkBlue: '#254a61',
  Violet: '#7a4fa3',
  LightViolet: '#f5f0fa',
  LightOrange: '#ffa500',
  LightLightOrange: '#fffcf1',
  Orange: '#b4530a',
  DarkDarkGray: '#202020',
  GoldenBrown: '#d48806',
  Headline: '#404040',
  ChartBlue: '#5470c6',
  ChartGreen: '#91cc75',
  ChartYellow: '#fac858',
};

export const RacemapPlayStoreLink = 'https://play.google.com/store/apps/details?id=racemap.de';
export const RacemapAppStoreLink = 'https://apps.apple.com/us/app/racemap/id640797527';

export const RacemapOrgaPlayStoreLink =
  'https://play.google.com/store/apps/details?id=com.racemap.orga.app&pcampaignid=web_share';
export const RacemapOrgaAppStoreLink = 'https://apps.apple.com/us/app/racemap-orga/id1668767086';

// The window width ladder, on bootstrap breakpoints. Pick a step by what the layout needs:
// phone is single column and touch controls, tablet still fits a desktop layout but no sidebar.
export const PhoneMaxWidth = 767;
export const TabletMaxWidth = 991;
export const TinyPhoneMaxWidth = 480;
